export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11501.2f7f02ce.jpg";